import Vue from 'vue'

Vue.filter( 'timestamp2txt' , function(timestamp){
    timestamp =  parseInt(timestamp);
    var oDate = new Date(timestamp*1000);
    var y = oDate.getFullYear();
    var m = oDate.getMonth() + 1;
    var d = oDate.getDate();
    var hour = oDate.getHours();
    var min = oDate.getMinutes();

    var curDate =  new Date();
    var cy = curDate.getFullYear();
    var cm = curDate.getMonth() + 1;
    var cd = curDate.getDate();

    var pre = ''
    console.info(y ,cy)
    if ( y !== cy ){
        pre= y + '-' + numFormat(m) + '-' + numFormat(d);
    } else {
        pre= numFormat(m) + '-' + numFormat(d);
    }

    if ( y == cy && m == cm ) {
        var day =  cd - d;
        if ( day == 0 ) {
            pre =  '今天';
        } else if ( day == 1 ) {
            pre = '昨天';
        } else if ( day == 2 ) {
            pre = '前天';
        }
    }

    return pre + ' ' + numFormat(hour) + ':' + numFormat(min)
});

function numFormat( num ){
    return parseInt(num) < 10 ? '0' + num : num;
}



// WEBPACK FOOTER //
// ./src/filter.js